import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import * as actions from '../../features/project-on-board/redux/actions';
import CustomLoader from '../common/CustomLoader';
import { CollectionShortDetail } from '.';

export class ListCollection extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  render() {
    const { projectId, projectOnBoard } = this.props;
    const { projectCollections, loadCollectionForProjectOnBoardPending } = projectOnBoard;

    return (
      <div className="mt-3">
        {loadCollectionForProjectOnBoardPending && (
          <CustomLoader loading={loadCollectionForProjectOnBoardPending} />
        )}
        <Accordion allowZeroExpanded>
          {projectCollections.map(collection => (
            <AccordionItem key={collection.uuid}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <strong>{collection.collectionTitle}</strong>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <CollectionShortDetail collection={collection} projectId={projectId} />
              </AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListCollection);
